import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const Home = lazy(() => import("./components/homepage/home"));
const Products = lazy(() => import("./components/products/products"));
const Contacts = lazy(() => import("./components/contacts"));
const AboutUs = lazy(() => import("./components/about/aboutUs"));
const Service = lazy(() => import("./components/service/service"));
const FAQ = lazy(() => import('./components/faq'));
const Cart = lazy(() => import('./components/cart'));
const Checkout = lazy(() => import('./components/checkout'));

const Routes = () => {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/products" component={Products} />
          <Route path="/about" component={AboutUs} />
          <Route path="/service" component={Service} />
          <Route path="/contacts" component={Contacts} />
          <Route path="/faq" component={FAQ} />
          <Route path="/cart" component={Cart} />
          <Route path="/checkout" component={Checkout} />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default Routes;
